class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay'));
        this.expiresDate = this.popup.getAttribute('data-expire');
        // Se o cookie existir, não mostra a popup
        if (this.getCookie('newsletter-popup') === ''){
            setTimeout(() => {
                document.body.classList.add('newsletter-show');
            }, this.timeToShow);

            setTimeout(() => {
                document.body.classList.add('show-newsletter-image');
            }, this.timeToShow + 700);
        }
        
        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        this.querySelector('[data-close-newsletter-popup]').addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );

        this.querySelector('#ContactPopup')?.addEventListener(
            'submit',
            this.setClosePopup.bind(this)
        );

        // NOVO: Evento ao clicar/mudar o checkbox "Não mostrar novamente"
        this.dismissCheckbox = this.querySelector('[data-dismiss-popup]');
        if (this.dismissCheckbox) {
            this.dismissCheckbox.addEventListener('change', this.onDismissChange.bind(this));
        }
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }

    // NOVO: Se o usuário marcar o checkbox, salva o cookie imediatamente e fecha a popup após 500ms
    onDismissChange(event) {
        if (event.target.checked) {
            this.setCookie('newsletter-popup', 'closed', this.expiresDate);
            
            // Fecha a popup suavemente logo após marcar
            setTimeout(() => {
                this.closePopupLayout();
            }, 500);
        }
    }

    // Modificado: Apenas fecha visualmente o popup
    closePopupLayout() {
        document.body.classList.remove('newsletter-show');
        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700);
    }

    // Executado ao clicar no "X" ou fora do popup
    setClosePopup() {
        // Se o checkbox de dismiss NÃO estiver marcado, a popup fechará apenas para a sessão atual (cookie expira em 1 dia)
        // Se preferir que NUNCA salve cookie no 'X', comente a linha abaixo.
        if (this.dismissCheckbox && !this.dismissCheckbox.checked) {
            this.setCookie('newsletter-popup', 'closed', 1); // 1 dia de respiro
        }
        
        this.closePopupLayout();
    }

    onBodyClickEvent(event){
        if ((!this.contains(event.target)) && ($(event.target).closest('[data-open-newsletter-popup]').length === 0) && document.querySelector('body').classList.contains('newsletter-show')){
            this.setClosePopup();
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);

class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[data-close-newsletter-message-popup]').addEventListener(
            'click',
            this.close.bind(this)
        );
        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }
    close(){
        document.body.classList.remove('newsletter-message-show');
    }
    onBodyClickEvent(event){
        if (!this.contains(event.target)){
            this.close();
        }
    }
}
customElements.define('newsletter-message-popup', NewsletterMessagePopup);